module.exports = __webpack_public_path__ + "static/destined-for-war-4031e6dc614829c13f75c428e77ffcc1.jpg";